import React from "react";
import SellInfoEdit from "../sellerInformation/SellInfoEdit";
import VerifyInfoEdit from "./VerifyInfoEdit";
import BankDetailsEdit from "./BankDetailsEdit";
import StoreDetailsEdit from "./StoreDetailsEdit";

const EditProfile = ({ profiledate, HandleGEtsellerProfile, sellerId }) => {
  console.log(sellerId);
  return (
    <div>
      <div>
        <SellInfoEdit
          profiledate={profiledate}
          HandleGEtsellerProfile={HandleGEtsellerProfile}
          sellerId={sellerId}
        />
      </div>
      <div>
        {!sellerId && (
          <VerifyInfoEdit profiledate={profiledate} sellerId={sellerId} />
        )}
      </div>
      <div>
        {!sellerId && (
          <BankDetailsEdit profiledate={profiledate} sellerId={sellerId} />
        )}
      </div>
      <div>
        <StoreDetailsEdit profiledate={profiledate} sellerId={sellerId} />
      </div>
    </div>
  );
};

export default EditProfile;
